module.exports = __webpack_public_path__ + "media/customizations/newfield/back-f8d245bdbe0b6f8bb43c0a2a71caad53.jpg";